"use client";
import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "./button";

export default function ThemeSetter() {
  const [theme, setTheme] = useState<string | null>(null); // Initial theme state

  useEffect(() => {
    // Check if a theme is saved in localStorage
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme) {
      setTheme(savedTheme);
    } else {
      // If no theme is saved, check system preference
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
      const systemTheme = prefersDark ? "dark" : "light";
      setTheme(systemTheme);
    }
  }, []);

  useEffect(() => {
    if (theme) {
      // Remove any previous theme classes ('light', 'dark')
      document.body.classList.remove("light", "dark");

      // Add the current theme class
      document.body.classList.add(theme);
    }
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme); // Save the new theme to localStorage
  };

  return (
    <div>
      <Button
        variant={"ghost"}
        size={"icon"}
        onClick={() => {
          toggleTheme();
        }}
        className="icon-button"
      >
        {theme === "light" ? <Moon size={18} /> : <Sun size={18} />}
      </Button>
    </div>
  );
}
